import React, { useMemo } from 'react'
import { isEmpty } from 'lodash'

import type { ExperimentVariable, FeatureVariable } from '../../types'
import { StyledVariable, type StyledVariableProps } from '../StyledVariable'

type StyledFeatureVariableProps = Omit<StyledVariableProps, 'text'> & {
  variables?: ExperimentVariable
  variableName: string
  textKey?: string
}

export const InnerStyledFeatureVariable = ({
  variables,
  variableName,
  textKey = 'text',
  defaultCopy = <></>,
  ...props
}: StyledFeatureVariableProps) => {
  const variable = useMemo(
    () => variables?.[variableName] as FeatureVariable,
    [variableName, variables],
  )
  if (isEmpty(variable)) return defaultCopy

  const text = variable[textKey]

  return <StyledVariable text={text} defaultCopy={defaultCopy} {...props} />
}
